import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import {
  useContractFormConfig,
  ContractFormProps,
} from "../../../components/UniversalForm/entityForms";

const ContractForm: React.FC<ContractFormProps> = (props) => {
  const config = useContractFormConfig(props);
  return (
    <>
      <style>{`
        .contract-form-responsive {
          max-width: 615px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .contract-form-responsive {
            max-width: 922px;
          }
        }
      `}</style>
      <div className="contract-form-responsive">
        <UniversalForm config={config} />
      </div>
    </>
  );
};

export default ContractForm;
